import {BaseDalService} from "@hec/core";
import {AppConfiguration, ApplicationService} from "@hec/models";
import axios, {AxiosInstance} from "axios";
import {FrameDto, SectionFragmentDto} from "@hec/api-dtos";

export class SelectableSectionFragmentsService extends BaseDalService implements ApplicationService {

  private client: AxiosInstance;
  public static override serviceName = Symbol('SelectableSectionFragmentsService');

  constructor() {
    super();
    this.client = axios.create({});
  }

  override configure(configuration: AppConfiguration) {
    this.client = axios.create({
      baseURL: `${configuration.baseUrl}/api/SectionFragments`,
    });

    this.useDateTimeConverters(this.client);
    this.useEnumConverters(this.client);
  }


  getName(): symbol {
    return SelectableSectionFragmentsService.serviceName;
  }

  static override getName(): symbol {
    return SelectableSectionFragmentsService.serviceName;
  }

  async get(configurationTemplateId: string, orderConfigurationCode: string): Promise<SectionFragmentDto[]> {

    this.configureAuthInterceptor(this.client, orderConfigurationCode);

    const response = await this.client.get(`?ConfigurationTemplateId=${configurationTemplateId}`)//&sectionFragmentType=Frame`);

    if (response.status === 200) {
      return response.data as SectionFragmentDto[];
    }

    throw new Error(`SelectableSectionFragmentsService: get resulted in ${response.status}: ${response.statusText}`);
  }
}
